<script>
    const apiConfig = {
        //authBaseURI: 'http://localhost:8000/api-v1/auth',
        //appBaseURI: 'http://localhost:8000/api-v1/web-api/pos',
        //authBaseURI: 'http://192.168.1.172:8000/api-v1/auth',
        //appBaseURI: 'http://192.168.1.172:8000/api-v1/web-api/pos',
        //authBaseURI: 'https://ite-dev.digibox-pos.com/api-v1/auth',
        //appBaseURI: 'https://ite-dev.digibox-pos.com/api-v1/web-api/pos',
        authBaseURI: 'https://ite-prod.digibox-pos.com/api-v1/auth',
        appBaseURI: 'https://ite-prod.digibox-pos.com/api-v1/web-api/pos',
    };
    export default apiConfig;
</script>
